import { HTMLAttributes } from 'react';

import './styles.scss';

export function AnonymousArea({
  children,
  className = '',
  ...remainingProps
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...remainingProps} className={`anonymous-area ${className}`}>
      {children}
    </div>
  );
}
